export function useDialogLoadingGuard(
  onOpenChange: (open: boolean) => void,
  loading: boolean,
) {
  const handleOpenChange = (value: boolean) => {
    if (!value && loading) return;
    onOpenChange(value);
  };

  const preventWhenLoading = (e: { preventDefault(): void }) => {
    if (loading) e.preventDefault();
  };

  return { handleOpenChange, preventWhenLoading };
}

const MAX_WIDTH_CLASSES = {
  md: "sm:max-w-md",
  lg: "sm:max-w-lg",
  xl: "sm:max-w-3xl",
} as const;

export type MaxWidth = keyof typeof MAX_WIDTH_CLASSES;

export function getMaxWidthClass(maxWidth: MaxWidth): string {
  return MAX_WIDTH_CLASSES[maxWidth];
}
